import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';
import LabelInput from 'library/components/unstyled-input';
import MonthSelect from 'library/components/form-elements/month';
import YearSelect from 'library/components/form-elements/year';

import 'apps/pathways/styles/start/main.scss';

class Education extends React.PureComponent {
  render() {
    const { onChange, date_range, active } = this.props;

    const [start_year, start_month] = resolve(date_range, 'start', '--').split(
      '-'
    );
    const [finish_year, finish_month] = resolve(
      date_range,
      'finish',
      '--'
    ).split('-');

    return (
      <div className="experiences-form-container">
        <section>
          <LabelInput
            label="School"
            required={active}
            disabled={!active}
            name="school"
            type="input"
            onChange={onChange}
            placeholder="School"
            value={resolve(this.props, 'school', '')}
          />

          <label htmlFor="degree">
            Degree
            <select
              aria-label="degree"
              required={active}
              disabled={!active}
              aria-required="true"
              onChange={onChange}
              value={resolve(this.props, 'degree', '')}
              name="degree"
              id="degree"
            >
              <option value="">-- Degree Type --</option>
              <option value="high-school">High School</option>
              <option value="associates">Associates</option>
              <option value="bachelors">Bachelors</option>
              <option value="masters">Masters</option>
              <option value="doctorate">Doctorate</option>
            </select>
          </label>
        </section>

        <section>
          <LabelInput
            label="Field of Study"
            disabled={!active}
            required={active}
            name="field_of_study"
            type="input"
            onChange={onChange}
            placeholder="Field of Study"
            value={resolve(this.props, 'field_of_study', '')}
          />

          <label htmlFor="time-period">
            Time Period
            <div name="time-period" className="experience-select-group">
              <div name="start" className="experience-select-group">
                <MonthSelect
                  required={active}
                  onChange={onChange}
                  disabled={!active}
                  aria-label="start_month"
                  aria-required="true"
                  name="start_month"
                  id="start_month"
                  value={start_month}
                />
                <YearSelect
                  required={active}
                  onChange={onChange}
                  disabled={!active}
                  aria-label="start_year"
                  aria-required="true"
                  name="start_year"
                  id="start_year"
                  value={start_year}
                />
              </div>
              <span> TO </span>
              <div name="finish" className="experience-select-group">
                <MonthSelect
                  required={active}
                  onChange={onChange}
                  disabled={!active}
                  aria-label="finish_month"
                  aria-required="true"
                  name="finish_month"
                  id="finish_month"
                  value={finish_month}
                />
                <YearSelect
                  required={active}
                  onChange={onChange}
                  disabled={!active}
                  aria-label="finish_year"
                  aria-required="true"
                  name="finish_year"
                  id="finish_year"
                  value={finish_year}
                />
              </div>
            </div>
          </label>
        </section>

        <section>
          <label className="experience-description" htmlFor="description">
            Description
            <textarea
              aria-label="this is a text area to describe your experience"
              disabled={!active}
              required={active}
              onChange={onChange}
              value={resolve(this.props, 'description', '')}
              name="description"
              id="description"
              rows={9}
            />
          </label>
        </section>
      </div>
    );
  }
}

Education.propTypes = {
  date_range: PropTypes.object,
  degree: PropTypes.string,
  description: PropTypes.string,
  school: PropTypes.string,
  onChange: PropTypes.func,
  field_of_study: PropTypes.string,
  active: PropTypes.bool,
};

export default Education;
